import React from "react";
import {TableContext,RowContext,TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {
    getFeConfig,
    visualize,
    insertIntermediaryInfo,
    fetchIntermediaryInstructions,
    insertIntermediaryWithoutFile, updateAccessInformation, updateIntermediaryInstructionFile
} from "../api/api";
import {Button, Modal, Upload, Space, Typography, notification, Table as TableAntd} from "antd";
import '../styles/GenralContractDocuments.css'
import {Form} from "@q4us-sw/q4us-ui";
import {
    InboxOutlined,
    CloudDownloadOutlined,
    UploadOutlined, EditOutlined
} from '@ant-design/icons'
import {unstable_batchedUpdates} from "react-dom";
import TextArea from "antd/es/input/TextArea";

const DownloadReplaceComponent = (props) => {
    const {row, index} = props;
    const [hasFile,setHasFile] = React.useState(row.instructions_file_name !== null)
    const [instructions_file_name,setInstructions_file_name] = React.useState(row.instructions_file_name)
    return <TableContext.Consumer>
        { table => <Space direction={'horizontal'} key={index}>
            {hasFile ? <Button icon={<CloudDownloadOutlined />} onClick={async () => {
                await fetchIntermediaryInstructions(row.id,instructions_file_name);

            }}/> : <div>
                No file
            </div>}

            <Upload
                maxCount={1}
                fileList={[]}
                progress={{
                    showInfo: false
                }}
                customRequest={async (opt)=>{
                    const formData = new FormData();
                    formData.append('intermediary_id',row.id);
                    formData.append("instructions_file",opt.file);

                    const res = await updateIntermediaryInstructionFile(formData);
                    const {status} = res
                    if(status === 200){
                        notification.success({message: `File replaced successfully`})
                        setInstructions_file_name(opt.file.name)
                        setHasFile(true)
                    }
                    else {
                        notification.error({message: `File replace failed`})
                    }
                }}>

                <Button icon={<UploadOutlined />}>Replace</Button>
            </Upload>
        </Space>}
    </TableContext.Consumer>
}


const UploadItem = ({value, onChange})=>{

    return <Upload.Dragger
        maxCount={1}
        fileList={value ? [value]: []}
        progress={{
            showInfo: false
        }}
        onRemove={()=>onChange(undefined)}
        customRequest={(opt)=>{
            onChange(opt.file)
            opt.onSuccess()
        }}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Upload.Dragger>
}


export const IntermediaryInfoForm = ({onSubmit, onCancel}) => {

    return <TableContext.Consumer>
        {
            table => <Form
                maxHeight={`60vh`}
                schema={`intermediary_info`}

                config={async (schema) => {
                    const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                    return rows;
                }}

                overrideComponent={(schema, element)=>{
                    if(schema === 'intermediary_info'){
                        if(element.name === 'instructions_file'){
                            return <UploadItem key={`instructions_file`}/>
                        }
                    }
                    if(schema === 'intermediary_info'){
                        if(element.name === 'access_information'){
                            return <TextArea/>
                        }
                    }
                }}

                rejected={()=>onCancel()}
                submit={async (values) => {

                    table?.setLoading(true)
                    const {intermediary_name, country_of_registration, scheme, access_information, instructions_file, instructions_file_name} = values
                    const formData = new FormData();

                    if (instructions_file === undefined) {
                        const response = await insertIntermediaryWithoutFile(intermediary_name, country_of_registration, scheme, access_information);

                        const {status} = response
                        if(status === 200){
                            const tableData = await table?.props.fetchData({schema: table?.props.schema}) || {};
                            notification.success({message: `Information entered successfully`})
                            unstable_batchedUpdates(() => {
                                table?.setData(tableData.data?.rows || [])
                                table?.setLoading(false)
                            })
                        }
                        else{
                            notification.error({message: `Information entering failed`})
                            table?.setLoading(false)
                        }
                    }
                    else {
                        let temp_access_information
                        if (access_information === undefined || access_information === null) {
                            temp_access_information = "";
                        } else {
                            temp_access_information = access_information
                        }
                        formData.append('intermediary_name',intermediary_name);
                        formData.append('country_of_registration', country_of_registration)
                        formData.append('scheme',scheme)
                        formData.append('access_information',temp_access_information)
                        formData.append("instructions_file",instructions_file);

                        const res = await insertIntermediaryInfo(formData);

                    const {status} = res
                    if(status === 200){
                    const tableData = await table?.props.fetchData({schema: table?.props.schema}) || {};
                    notification.success({message: `Information entered successfully`})
                    unstable_batchedUpdates(() => {
                    table?.setData(tableData.data?.rows || [])
                    table?.setLoading(false)
                })
                }else{
                    notification.error({message: `Information entering failed`})
                    table?.setLoading(false)
                }
                    }

                    return await onSubmit()
                }}/>
        }
    </TableContext.Consumer>
};


export const IntermediaryInformation = (props) => {

    const [open,setOpen] = React.useState(false)
    const [visible,setVisible] = React.useState(false)

    const [accessInfoForModalTextarea, setAccessInfoForModalTextarea] = React.useState({
        id: null,
        access_information: ""
    })

    const onModalTextAreaChange = (e) => {
        setAccessInfoForModalTextarea({...accessInfoForModalTextarea,access_information:e.target.value})
    }
    const onAccessInfoModalSubmit = async () => {
        await updateAccessInformation(accessInfoForModalTextarea.id, accessInfoForModalTextarea.access_information)
        setVisible(false)
    }

    return <div className={`general-contract-content`}>
        <TableV2
            header={<div className={`general-contract-header`}>
                <Typography.Title level={3}>Intermediary Information</Typography.Title>
                <div className={`spacer`}/>
                <Button onClick={()=>setOpen(true)}>Add New Record</Button>
            </div>}
            shouldRefresh={(operation, status)=> {return operation === TableOperation.Update | TableOperation.Delete}}
            fetchConfig={async (schema) => {
                const {data= {}} = await getFeConfig('intermediary_info')
                const { statusCode, rows = []} = data;

                const rows2 = rows.map( x=> {
                    if(x.name === 'instructions_file'){
                        const formatter = (row,table, tableData) =>{
                            const filename= row.name;
                            return DownloadReplaceComponent({row}, table, tableData, filename);
                        }
                        return {...x, formatter}
                    }
                    return x
                })

                return { data: { statusCode, rows: rows2 } };
            }}
            customRenderer={{
                access_information: (value, row)=>{

                    return [
                        <React.Fragment>
                        <p>{value}</p>
                        <Button key={'btn'} onClick={async () =>{
                            setVisible(true);
                            setAccessInfoForModalTextarea({
                                id: row.id,
                                access_information: value
                            });

                        }} icon={<EditOutlined />} />
                        </React.Fragment>
                    ]
                }
            }}
            fetchData={async (request) => {
                return await visualize("intermediary_information")
            }}
            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
        >
            <Modal
                onCancel={() => setOpen(false)}
                footer={null}
                closable={true}
                title={'Add Intermediary Information'}
                visible={open}
            >
                <IntermediaryInfoForm onCancel={()=>setOpen(false)} onSubmit={()=> {
                    setOpen(false)
                    return true;
                }}/>
            </Modal>

            <Modal
                onCancel={() => setVisible(false)}
                onOk={onAccessInfoModalSubmit}
                closable={true}
                title={'Edit Access Information'}
                visible={visible}
            >
                <TextArea value={accessInfoForModalTextarea.access_information} onChange={onModalTextAreaChange}/>
            </Modal>
        </TableV2>
    </div>


}
